<template>
<div id="friends-list">
	<div class="friends">
		<div class="title a"
			@click="collapse.online = !collapse.online">
			<span class="num">{{ onlineFriends.length }}</span>Online Friends
		</div>
		<div v-show="!collapse['online']"
			class="list">
			<user-line v-for="(user) in onlineFriends"
				:key="user.id+'-'+user.friendOf.id"
				:user="user" />
		</div>
	</div>
	<div class="offline-friends">
		<div class="title a"
			@click="collapse.offline = !collapse.offline">
			<span class="num">&nbsp;</span>Other Friends
		</div>
		<div v-show="!collapse['offline']"
			class="list">
			<user-line v-for="(user) in offlineFriends"
				:key="user.id+'-'+user.friendOf.id+'offline'"
				:user="user" />
		</div>
	</div>
	<div class="accounts">
		<div class="title a"
			@click="collapse.characters = !collapse.characters">
			<span class="num">&nbsp;</span>Characters
		</div>
		<div v-show="!collapse['characters']"
			class="list">
			<user-line v-for="(user) in account.users"
				:key="user.id"
				:user="user" />
		</div>
	</div>
	<div v-if="blocks.length"
		class="blocked">
		<div class="title a"
			@click="collapse.blocked = !collapse.blocked">
			<span class="num">&nbsp;</span>Blocked
		</div>
		<div v-show="!collapse['blocked']"
			class="list">
			<user-line v-for="(user) in blocks"
				:key="user.id"
				:user="user" />
		</div>
	</div>
</div>
</template>

<script>
import account from '../js/account.js'
import UserLine from './user-line.vue'
import { getUserById, getUserByName } from '../js/user-functions.js'
import { computed, watch, reactive } from 'vue'

global.getUserByName = getUserByName
global.getUserById = getUserById

export default {
	components: {
		UserLine
	},
	setup(){
		const collapse = reactive({
				online: false,
				offline: true,
				characters: true,
				blocked: true
			}),
			friends = reactive( [] ),
			blocks = reactive( [] ),
			onlineFriends = computed(
				() => friends.filter( ( friend ) => friend.props && friend.props.online )
			),
			offlineFriends = computed(
				() => friends.filter( ( friend ) => friend.props && !friend.props.online )
			)

		watch(
			() => account.users,
			( items, oldItems ) => {
				account.users.forEach( ( user ) => {
					user.priv.friends.forEach( async( friendid ) => {
						const friend = await getUserById( friendid )

						friend.friendOf = user
						if( !friends.some( ( aFriend ) => aFriend.props.name === friend.props.name ) ){
							friends.push( friend )
						}
					})
				})
			},
			{
				deep: true,
				immediate: true
			}
		)

		watch(
			() => account.ignores.length,
			( length ) => {
				account.ignores.forEach( async( blockedid ) => {
					const blocked = await getUserById( blockedid )

					if( !blocks.includes( blocked ) ){
						blocks.push( blocked )
					}
				})
			},
			{ immediate: true }
		)

		return {
			onlineFriends,
			offlineFriends,
			blocks,
			account,
			collapse
		}
	}
}
</script>

<style>
	#friends-list .num {
		width: 1em;
		font-size: 150%;
		vertical-align: middle;
		display: inline-block;
		text-align: center;
	}
	.title {
		white-space: nowrap;
	}
</style>
